module.exports = __webpack_public_path__ + "img/grinning-squinting-face.ddfc07ca.png";